import {
    getPropertiesForProjectWizardABCTest,
    trackEvent,
    trackEventInAnalytics,
    trackPixelCustomEvent,
} from './analytics-actions';
import { CUSTOM_EVENT_PUBLISHED_PROJECT, CUSTOM_EVENT_PUBLISHED_PROJECT_DUGNAD } from './analytics-events';
import {
    directDonationInGa4ItemStructure,
    directDonationInPostHogItemStructure,
    getDirectDonationAmountOfTransactionWithRewards,
    getTotalPaidForRewards,
    rewardInGa4ItemStructure,
    rewardInPostHogItemStructure,
} from '../project/reward/reward-model';
import { isBirthdayProject, isChristmasProject, isProjectADugnad } from '../project/project-model';
import { getPaymentMethodTextFromTransaction } from '../transaction/transaction-model';

export const trackProjectPublish = ({ project, projectWizardABCTest, trigger, startOrigin }) => {
    const isOwnerOrg = project.owner?.type === 'org';
    const isReceiverOrg = project.receiver?.type === 'org';
    trackEvent('admin', 'project-publish', {
        'project-id': project.id,
        'event-id': project.event_id,
        'template-id': project.template_id,
        dugnad: !!project.profile?.dugnad,
        'owner-is-org': isOwnerOrg,
        'receiver-is-org': isReceiverOrg,
        'publish-trigger': trigger,
        'start-origin': startOrigin,
        ...getPropertiesForProjectWizardABCTest(projectWizardABCTest),
    });
    trackEvent('admin', 'banner-click', { 'project-id': project.id, 'banner-type': 'publish' });
    trackPixelCustomEvent('PublishProject', {
        project_type: getProjectTypeForTracking({ project }),
        template_id: project.template_id,
    });
    const sharedAnalyticsParameters = {
        owner_is_org: isOwnerOrg,
        receiver_is_org: isReceiverOrg,
    };
    if (project.profile?.dugnad) {
        trackEventInAnalytics(CUSTOM_EVENT_PUBLISHED_PROJECT_DUGNAD, sharedAnalyticsParameters);
    } else {
        trackEventInAnalytics(CUSTOM_EVENT_PUBLISHED_PROJECT, sharedAnalyticsParameters);
    }
};

export const getProjectTypeForTracking = ({ project }) => {
    if (isProjectADugnad(project)) {
        return 'dugnad';
    }

    if (isBirthdayProject(project)) {
        return 'birthday';
    }

    if (isChristmasProject(project)) {
        return 'christmas';
    }

    return 'standard';
};

export const trackProjectPayment = ({ event, cartSum, cartItems }) => {
    trackEventInAnalytics(event, {
        currency: 'NOK',
        value: cartSum,
        items: cartItems.map((i) => rewardInGa4ItemStructure(i.reward, i.count)),
    });
};

export const transactionInPurchaseStructure = ({ transactionId, amount, rewards }) => {
    return {
        currency: 'NOK',
        transaction_id: transactionId,
        value: amount,
        items:
            rewards?.length > 0
                ? rewards?.map((reward) => rewardInGa4ItemStructure(reward, reward.purchased_count))
                : [directDonationInGa4ItemStructure(amount)],
    };
};

export const mapTransactionToPaymentEventProperties = ({ transaction, rewards, project, extraProperties = {} }) => {
    const items = rewards?.map((reward) => rewardInPostHogItemStructure(reward, reward.purchased_count)) || [];
    const amountRewards = getTotalPaidForRewards(rewards);
    const amountDirectDonation = getDirectDonationAmountOfTransactionWithRewards({
        amount: transaction.amount,
        rewards,
    });
    if (amountDirectDonation > 0) {
        const directDonationItem = directDonationInPostHogItemStructure(amountDirectDonation);
        items.push(directDonationItem);
    }
    return {
        ...extraProperties,
        project_id: transaction.to_project,
        amount: parseInt(transaction.amount, 10),
        amount_direct_donation: amountDirectDonation,
        amount_rewards: amountRewards,
        items,
        transaction_count: project?.transaction_count,
        did_consent_to_personalized_newsletter: transaction?.from_user_meta_data?.consentedToPersonalizedNewsletter,
        category: project?.categories?.[0],
        projectHasGiverFee: project?.pricing?.staticGiverFee && parseInt(project.pricing.staticGiverFee, 10) > 0,
        payment_method: getPaymentMethodTextFromTransaction(transaction),
    };
};
